<template>
    <div class="">
        <div class="tabs_content">
            <ul>
                <li class="active"><Badge :count="unread.ordernum">业务消息</Badge></li>
                <li @click="orderjump(2)"><Badge :count="unread.helpnum">公司通知公告</Badge></li>
                <li @click="orderjump(3)"><Badge :count="unread.msgnum">留言咨询</Badge></li>
            </ul>
        </div>
        <div class="news_list_content" v-if="listshow">
            <ul>
                <li v-for="(item, index) in newslist" :key="index" @click="listClick(item)">
                    <div class="news_list_left unread" :class="{no: item.is_new == 0}">
                        <div class="news_list_title"><span>{{item.content}}</span></div>
                    </div>
                    <div class="news_list_right"><span>{{item.addtime}}</span></div>
                </li>
            </ul>
        </div>
        <noMsg v-if="notips"></noMsg>
        <Loadings v-if="loading"></Loadings>
        <div class="news_bottom_page_content" v-if="listshow">
            <a href="javascript:;" @click="messageread">全部标为已读</a>
            <!-- 分页 -->
            <div class="page_content">
                <Page
                    :total="pagetotal"
                    :current="pagecurrent"
                    :page-size="pagesize"
                    :page-size-opts="pagesizeopts"
                    show-total
                    show-sizer
                    show-elevator
                    @on-change="pageChange"
                    @on-page-size-change="pageSizeChange" />
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
import noMsg from '@/components/component/nomsg.vue'
import Loadings from '@/components/component/loading.vue'
export default {
    components: {noMsg, Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            unread: { // 未读消息数量
                ordernum: 0,
                helpnum: 0,
                msgnum: 0,
            },
            newslist: [], // 消息列表
            readid: '', // 已读id 如果为空 全部标为已读
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            if (!this.$store.state.openmall) {
                this.listshow = false
                this.notips = false
                this.loading = true
                this.http.post(api.message,
                    {
                        type: 1,
                        page: this.pagecurrent,
                        pagesize: this.pagesize
                    }
                )
                .then(response => {
                    console.log(response.data.msg)
                    this.unread = response.data.msg.num
                    this.newslist = response.data.msg.log_orderlog
                    this.pagetotal = response.data.msg.log_pagecontent.num
                    this.loading = false
                    response.data.msg.log_orderlog.length > 0 ? this.listshow = true : this.notips = true
                })
                .catch(error => {
                    console.log(error);
                })
            } else {
                this.notips = true
            }
        },
        messageread () { // 全部标为已读
            this.http.post(api.messageread, {type: 1, id: this.readid})
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                    this.readid = ''
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Notice'
            } else if (sign == 2) {
                link = '/News'
            } else {
                link = '/Message'
            }
            if (this.$store.state.openmall && link == '/Message') {
                this.$Message.warning('未登录客户不可留言，请联系客服')
            } else {
                this.$router.push(link)
            }
        },
        listClick (item) { // 点击列表
            this.readid = item.id
            this.messageread()
            if (item.type == 1) { // 1 订货单详情  2 退货单详情  3 预存款账户
                this.$router.push({
                    name: '订货详情',
                    params: {
                        id: item.orderid
                    }
                })
            } else if (item.type == 2) {
                this.$router.push({
                    name: '退货单订单详情',
                    params: {
                        id: item.orderid
                    }
                })

            } else if (item.type == 3) {
                this.$router.push('/DepositRecord')
                
            }
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/news/notice.vue